import { gql } from '@apollo/client'

export const SAVE_USER_INFO = gql`
  mutation Login($tokenId: String!) {
    login(tokenId: $tokenId) {
      accessToken
      user {
        userId
        firstName
        lastName
        email
        gsuiteUsername
        gid
        kind
        avatar
        role {
          name
        }
      }
    }
  }
`
